// extracted by mini-css-extract-plugin
module.exports = {"versionNumber":"styles_versionNumber__MxpOR"};